import type { NodeViewRenderers } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';

import {
  CollapsibleListItemBodyProperty,
  CollapsibleListItemTitleProperty,
} from './collapsibleItemProperty';
import CollapsibleList from './collapsibleList';
import CollapsibleListItem from './collapsibleListItem';

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.COLLAPSIBLE_LIST]: CollapsibleList,
  [Node_Type.COLLAPSIBLE_ITEM]: CollapsibleListItem,
  [Node_Type.COLLAPSIBLE_ITEM_TITLE]: CollapsibleListItemTitleProperty,
  [Node_Type.COLLAPSIBLE_ITEM_BODY]: CollapsibleListItemBodyProperty,
};
